import { render, staticRenderFns } from "./CbsConstructorAttrCard.vue?vue&type=template&id=4400d505&scoped=true"
import script from "./CbsConstructorAttrCard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorAttrCard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorAttrCard.vue?vue&type=style&index=0&id=4400d505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4400d505",
  null
  
)

export default component.exports